import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core'
import {faTimes} from '@fortawesome/pro-regular-svg-icons/faTimes'
import {LinkService} from '../../../core/i18n/link.service'
import {DocumentService} from '../../../craft/utils/document.service'
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons/faPencilAlt'
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser'
import {ProcessService} from './process.service'
import {TranslocoService} from '@ngneat/transloco'

@Component({
  selector: 'bgo-process-navbar',
  templateUrl: './process-navbar.component.html',
  styles: [
    `
      @reference '../../../../styles/app-reference.css';

      :host {
        @apply sticky top-0 z-10 bg-white shadow-1;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessNavbarComponent implements OnDestroy {
  @Input() currentStep = 1
  @Input() exitButtonText?: string
  @Input() agencyLogo?: {title?: string; url: string} | undefined
  readonly closeIcon = faTimes
  readonly pencilIcon = faPencilAlt
  readonly contactIcon = faUser
  readonly sendIcon = faPaperPlane

  constructor(
    private readonly documentService: DocumentService,
    private readonly processService: ProcessService,
    private readonly translocoService: TranslocoService,
    readonly linkService: LinkService,
  ) {}

  ngOnDestroy(): void {
    this.documentService.enablePageScroll()
  }

  close(): void {
    this.processService.close(this.exitButtonText ?? this.translocoService.translate('exitProcess'))
  }
}
